/* Forged Racing — horizontal carousel.
   Scroll-snap track + arrow controls. Native touch swipe via overflow scroll.
   Markup: [data-frg-carousel] > [data-frg-carousel-track] + prev/next buttons. */
(function () {
  'use strict';

  function setup(root) {
    var track = root.querySelector('[data-frg-carousel-track]');
    if (!track) return;
    /* Arrows sit in the section head, which is a SIBLING of [data-frg-carousel],
       not a child — so scope the lookup to the enclosing section and fall back
       to the root. (Previously root-only, which silently found nothing and left
       the prev/next buttons dead on every carousel.) */
    var scope = root.closest('.shopify-section') || root.parentNode || document;
    var prev = root.querySelector('[data-frg-carousel-prev]') || scope.querySelector('[data-frg-carousel-prev]');
    var next = root.querySelector('[data-frg-carousel-next]') || scope.querySelector('[data-frg-carousel-next]');

    function itemWidth() {
      var first = track.querySelector(':scope > *');
      var w = first ? first.getBoundingClientRect().width : 320;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0') || 0;
      return (w + gap) || 320;
    }

    function update() {
      var max = track.scrollWidth - track.getBoundingClientRect().width - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }

    /* Round 17 (item J): scrollBy(step, {behavior:'smooth'}) targeted a
       multi-item jump that generally landed BETWEEN snap points. Combined
       with `scroll-snap-type: x mandatory` on the track, the browser's snap
       correction fought the in-flight smooth-scroll animation — confirmed
       live that an identical smooth scrollTo() to a snap-aligned target
       still never completed, while the same target with behavior:'auto'
       moved instantly every time. Rounding the target to a whole multiple
       of the item width AND dropping 'smooth' removes the animation that
       was fighting the snap correction in the first place, trading a nice-
       to-have transition for arrows that are guaranteed to actually move. */
    function scrollToward(dir) {
      var clientW = track.getBoundingClientRect().width;
      var iw = itemWidth();
      var perPage = Math.max(1, Math.floor(clientW / iw));
      var max = track.scrollWidth - clientW;
      var current = Math.round(track.scrollLeft / iw);
      var target = Math.max(0, Math.min(max, (current + dir * perPage) * iw));
      track.scrollTo({ left: target, behavior: 'auto' });
      /* Don't rely solely on the 'scroll' event to refresh disabled state —
         call directly so button state is correct the instant the click
         handler returns, not on the next scroll-event/rAF tick. */
      update();
    }

    if (prev) prev.addEventListener('click', function () { scrollToward(-1); });
    if (next) next.addEventListener('click', function () { scrollToward(1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init() {
    document.querySelectorAll('[data-frg-carousel]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
